import styled from 'styled-components'
import { DESCRIPTION_STYLED_PROPS } from './interface'

export const Description = styled.div<DESCRIPTION_STYLED_PROPS>`
  font-size: 26px;
  margin-bottom: 30px;
  line-height: 1.33;
  color: ${({ colors }) => colors.secondary};
  h3 {
    text-transform: uppercase;
    margin-bottom: 13px;
    font-size: 20px;
  }
  h4 {
    font-size: 20px;
  }
  p {
    font-size: 18px;
    font-family: 'GT America, regular';
  }
`

export const DetailedDescription = styled.div`
  padding: 14px 20px;
  h4 {
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
  }
`

// EXPLANATION TABLE STYLES

export const TableContainer = styled.div<DESCRIPTION_STYLED_PROPS>`
  border-radius: 18px;
  border: solid 3px ${({ colors }) => colors.tertiary};
  width: 315px;
  margin: auto auto 30px;
  color: ${({ colors }) => colors.secondary};
`

export const Row = styled.div<DESCRIPTION_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-align: center;
  h4 {
    width: 50%;
    text-align: center;
    padding: 10px;
    border-top: solid 3px ${({ colors }) => colors.tertiary};
    border-bottom: solid 3px ${({ colors }) => colors.tertiary};
    text-transform: uppercase;
    :first-child {
      border-right: solid 3px ${({ colors }) => colors.tertiary};
    }
  }
`

// EXPLANATION DIAGRAM STYLES

export const Box = styled.div<DESCRIPTION_STYLED_PROPS>`
  padding: 10px 0;
  border: solid 3px ${({ colors }) => colors.secondary};
  margin: 10px auto;
  text-transform: uppercase;
  position: relative;
  width: 120px;
  font-size: 12px;
  text-align: center;
  &&.round {
    border-radius: 23px;
  }
  svg {
    transform: translateY(1px) translateX(3px);
  }
`

export const Column = styled.div<DESCRIPTION_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  min-height: 188px;
  border-bottom: solid 3px ${({ colors }) => colors.tertiary};
  &&.border-b {
    border-bottom: none;
  }
  :first-child {
    border-right: solid 3px ${({ colors }) => colors.tertiary};
  }
  :last-child {
    justify-content: center;
  }
`

export const Circle = styled.div<DESCRIPTION_STYLED_PROPS>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  background: ${({ colors }) => colors.primary};
  border: solid 1px ${({ colors }) => colors.secondary};
  z-index: 2;
  right: -5px;
  bottom: 50%;
  transform: translateY(50%);
  box-shadow: 0px 0px 0px 2px ${({ colors }) => colors.secondary};
  &&.left {
    right: unset;
    left: -5px;
  }
  &&.top {
    bottom: unset;
    top: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.bottom {
    bottom: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &.rightCorner {
    bottom: -5px;
    right: -5px;
    transform: translateY(0);
  }
  &.leftCorner {
    bottom: unset;
    top: -5px;
    left: -5px;
    transform: translateY(0);
  }
`
export const Line = styled.div<DESCRIPTION_STYLED_PROPS>`
  height: 3px;
  width: 40px;
  position: absolute;
  z-index: 1;
  background: ${({ colors }) => colors.secondary};
  right: -40px;
  bottom: 50%;
  transform: translateY(50%);
  &&.down {
    height: 30px;
    width: 3px;
    right: 50%;
    bottom: -30px;
    transform: translateY(0) translateX(50%);
  }
  &&.diagTop {
    bottom: 50%;
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(-57deg);
  }
  &&.diagBot {
    bottom: 50%;
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(57deg);
  }
  &&.diagBotLong {
    width: 100px;
    right: -100px;
    transform: translateY(0) translateX(0) rotate(66deg);
    bottom: 0;
    transform-origin: left;
  }
`

export const Romb = styled.div<DESCRIPTION_STYLED_PROPS>`
  padding: 10px 0;
  position: relative;
  border-top: solid 3px ${({ colors }) => colors.tertiary};
  border-bottom: solid 3px ${({ colors }) => colors.tertiary};
  margin: 10px auto;
  text-transform: uppercase;
  font-size: 12px;
  width: 90px;
  :after {
    content: '';
    position: absolute;
    border: solid ${({ colors }) => colors.secondary};
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(315deg);
    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    right: -13.5px;
  }
  :before {
    content: '';
    position: absolute;
    border: solid ${({ colors }) => colors.secondary};
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(135deg);
    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    left: -13.5px;
  }
`
